mmf_modules.define('main',[],function () {
    "use strict";
    window.mmf_require_init();
});
